import type { ChangeEventHandler } from "react";
import React, { useId } from "react";

import { Label, Switch } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  email_opt_in: boolean;
  onChange: (new_value: { email_opt_in: boolean }) => void;
}
export const NewsletterSection: React.FC<Props> = ({
  email_opt_in = false,
  onChange
}) => {
  const { translator } = useAppContext();

  const handleOptinChange: ChangeEventHandler<HTMLInputElement> = event => {
    onChange({ email_opt_in: event.target.checked });
  };

  const label_id = useId();

  return (
    <div className="flex flex-col gap-250">
      <Label fontWeight="bold" size="lg" as="span">
        {translator.t("!accounts.newsletter.title")}
      </Label>
      <div className="flex flex-row items-center justify-between">
        <Label
          size="md"
          as="span"
          className="text-color-secondary"
          id={label_id}
        >
          {translator.t("!accounts.newsletter.description")}
        </Label>

        <Switch
          isChecked={email_opt_in}
          ariaLabelledBy={label_id}
          onChange={handleOptinChange}
        />
      </div>
    </div>
  );
};
